/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LandInputs */

const en_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Style`)
};

const ar_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمط الأرض`)
};

const de_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land-Stil`)
};

const es_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de terreno`)
};

const fr_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de sol`)
};

const it_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile del terreno`)
};

const ja_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランドスタイル`)
};

const ko_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`랜드 스타일`)
};

const pt_br_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de terreno`)
};

const ru_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль земли`)
};

const th_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไตล์พื้นดิน`)
};

const tr_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arazi Türü`)
};

const zh_cn_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地皮肤`)
};

const zh_tw_land = /** @type {(inputs: LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地造型`)
};

/**
* | output |
* | --- |
* | "Land Style" |
*
* @param {LandInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land = /** @type {((inputs?: LandInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LandInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land(inputs)
	if (locale === "ar") return ar_land(inputs)
	if (locale === "de") return de_land(inputs)
	if (locale === "es") return es_land(inputs)
	if (locale === "fr") return fr_land(inputs)
	if (locale === "it") return it_land(inputs)
	if (locale === "ja") return ja_land(inputs)
	if (locale === "ko") return ko_land(inputs)
	if (locale === "pt_br") return pt_br_land(inputs)
	if (locale === "ru") return ru_land(inputs)
	if (locale === "th") return th_land(inputs)
	if (locale === "tr") return tr_land(inputs)
	if (locale === "zh_cn") return zh_cn_land(inputs)
	return zh_tw_land(inputs)
});